import { render, staticRenderFns } from "./ChangePwd.vue?vue&type=template&id=eb1fd602&scoped=true&"
import script from "./ChangePwd.vue?vue&type=script&lang=js&"
export * from "./ChangePwd.vue?vue&type=script&lang=js&"
import style0 from "./ChangePwd.vue?vue&type=style&index=0&id=eb1fd602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1fd602",
  null
  
)

export default component.exports